import { FC } from 'react';
import { MyLink } from '@app/shared';
import { Tooltip } from '@sharedUi/Tooltip';
import { BadgesTypeProps } from './TypeProps';
import { ContentTooltip } from './ContentTooltip';
import classNames from 'classnames';
import Image from 'next/image';

import styles from './Badges.module.scss';

export const Badges: FC<BadgesTypeProps> = ({ className, badges }) => {
  if (!badges?.length) {
    return null;
  }

  return (
    <div className={classNames(styles.WrapperBadges, className)}>
      {badges.map((badge, index) => {
        return (
          <div className={styles.Badge} key={`${badge.iconName}__${badge.text}__${index}`}>
            <Tooltip content={badge.items.length > 0 ? <ContentTooltip list={badge.items} /> : null} arrow>
              {badge.href ? (
                <MyLink href={badge.href}>
                  <Image
                    className={styles.BadgeIcon}
                    src={`/next/gimg/cart-product/${badge?.slug}`}
                    alt={badge?.slug}
                    width={26}
                    height={26}
                    layout={'fixed'}
                  />
                </MyLink>
              ) : (
                <Image
                  className={styles.BadgeIcon}
                  src={`/next/gimg/cart-product/${badge?.slug}`}
                  alt={badge?.slug}
                  width={26}
                  height={26}
                  layout={'fixed'}
                />
              )}
            </Tooltip>
          </div>
        );
      })}
    </div>
  );
};
